<template>
  <div
    class="lv-content-tab-bar"
    :class="{height:height,'mt-Lg':mtLg}"
  >
    <div class="lv-content-tab-bar__tab-wrap">
      <LvContentTab001
        v-for="(tab, tab_k) in contentTabs"
        :key="tab_k"
        :wide="wide"
        :num="tab.num"
        :isLoading="isLoading"
        :done-icon="tab.doneIcon"
        :text-label="tab.textLabel"
        :content-width="contentWidth"
        :class="{loading: tab.isLoading}"
        :activiated="$_getIsActiviated(tab)"
        @click="$_contentTabOnclick(tab,tab_k)"
      />
    </div>
    <div class="lv-content-tab-bar__btns-wrap">
      <slot name="btns"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "LvContentTabBar001",
  props: {
    doneIcon: {
      type: Boolean,
      default: false,
    },
    marginTop: {
      type: Number,
      default: 0,
    },
    selectedTabId: {
      type: String,
      default: "",
    },
    contentTabs: {
      type: Array,
      default() {
        return [];
      },
    },
    height: {
      type: Boolean,
      default: false,
    },
    contentWidth: {
      type: Number,
      default: 140,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    mtLg: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_getIsActiviated(tab) {
      return this.selectedTabId === tab.id;
    },
    $_contentTabOnclick(tab, tab_k) {
      const _tab = tab;
      _tab.index = tab_k;
      this.$emit("click", _tab);
    },
  },
};
</script>